export const UPDATE_ADMIN_APP_DATA = 'UPDATE_ADMIN_APP_DATA';
export const ADD_RULE_SET_TO_LIST = 'ADD_RULE_SET_TO_LIST';
export const DELETE_RULE_SET_IN_LIST = 'DELETE_RULE_SET_IN_LIST';
export const UPDATE_WIDTH_COLUMNS_RULE_SET = 'UPDATE_WIDTH_COLUMNS_RULE_SET'